var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("template-card-v2", {
    attrs: {
      "one-log": _vm.oneLog,
      linkedtype: _vm.linkedtype,
      linkedid: _vm.linkedid
    },
    scopedSlots: _vm._u([
      {
        key: "label",
        fn: function() {
          return [
            _c("person-list-light", {
              attrs: {
                list: _vm.oneLog.staffs.params.list,
                "placeholder-singular": "Collaborateur",
                "placeholder-plural": "Collaborateurs"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "icon",
        fn: function() {
          return [
            _c("CompassObject", { attrs: { object: "task", size: "small" } })
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.oneLog.canSee,
                    expression: "oneLog.canSee"
                  }
                ],
                staticClass: "task-card-content__container"
              },
              [
                _c("div", { staticClass: "task-card-information__container" }, [
                  _c(
                    "div",
                    { staticClass: "flex-column" },
                    [
                      _c(
                        "div",
                        { staticClass: "task-card-date__container" },
                        [
                          _c("CompassIcon", {
                            attrs: { size: "small", icon: "calendar-fill" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "typographies-paragraph-medium-semibold"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t.__(
                                      "common.labels.due_date",
                                      _vm.date
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isLate
                            ? _c("BadgeActivityStatus", {
                                attrs: { tag: _vm.activityStatus }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.oneLog.label
                        ? _c(
                            "CompassTag",
                            _vm._g(
                              {
                                staticClass: "task-card-tag",
                                attrs: {
                                  type: "dot",
                                  size: "small",
                                  color: !!_vm.oneLog.labelColor.length
                                    ? "custom"
                                    : "yellow",
                                  "custom-color": "#" + _vm.oneLog.labelColor
                                }
                              },
                              !_vm.oneLog.title
                                ? {
                                    click: function() {
                                      return _vm.previewTask(_vm.oneLog)
                                    }
                                  }
                                : {}
                            ),
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.oneLog.label) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "task-card-buttons__container" },
                    [
                      !_vm.isComplete
                        ? _c("TimelineActivityRescheduleButton", {
                            attrs: { activity: _vm.activityForReschedule }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("CompassButton", {
                        class: [
                          "task-card-action__container",
                          _vm.taskActionClass
                        ],
                        attrs: {
                          label: _vm.taskActionLabel,
                          type: "secondary",
                          leftIcon: "check"
                        },
                        on: { click: _vm.toggleCheckTask }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.oneLog.title
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "typographies-paragraph-medium-semibold task-card-title",
                        on: {
                          click: function($event) {
                            return _vm.previewTask(_vm.oneLog)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.oneLog.title) +
                            "\n            "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.oneLog.description
                  ? _c("div", {
                      staticClass:
                        "typographies-paragraph-medium-regular task-card__content rich-text-style",
                      class: _vm.editorClass,
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.addBrToEmptyPragraphs(_vm.oneLog.description)
                        )
                      }
                    })
                  : _vm._e()
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }